<template>
  <div>
    <div>
      <SystemAlert/>
    </div>

    <div class="declaimer">      
      <button
        type="button"
        class="app-btn-selectable app-btn-custom" 
        :class="{ '__active': isIndividual }"
        @click.prevent="toggleActiveClass({ indType: true })"
      >
        I'm an individual
      </button>

      <button 
        type="button" 
        class="app-btn-selectable app-btn-custom"
        :class="{ '__active': !isIndividual }"
        @click.prevent="toggleActiveClass({ indType: false })"
      >
        I'm a business     
      </button>
    </div>

    <!-- Individual users -->
    <div class="app-main-content guest-signin d-flex" v-if="isIndividual">  
      <div class="ind-signin">
        <h1>Sign in</h1>
        <div class="select-ind" >
          <div class="radio-group">
            <input type="radio" id="License-RI" class="radio-input" v-model="authorizeId" value="1" name="authorizeId" @change="resetForm()">
            <label for="License-RI" class="radio-label">I have RI License / ID card</label>
          </div>
          <div class="radio-group">
            <input type="radio" id="Vehicle-RI" class="radio-input" v-model="authorizeId" value="2" name="authorizeId" @change="resetForm()">
            <label for="Vehicle-RI" class="radio-label">I have a vehicle in RI</label>
          </div>
          <div class="radio-group">
            <input type="radio" id="Violation-Suspension-RI" class="radio-input" v-model="authorizeId" value="3" name="authorizeId" @change="resetForm()">
            <label for="Violation-Suspension-RI" class="radio-label">I have a violation / suspension in RI </label>
          </div>
          <div class="radio-group"> 
            <input type="radio" id="Crash-RI" class="radio-input" v-model="authorizeId" value="4" name="authorizeId" @change="resetForm()">
            <label for="Crash-RI" class="radio-label">I have a crash record in RI</label>
          </div>
        </div>
        <LoginForm :selectId="String(authorizeId)" ref="loginFormRef"/>
      </div>
      <div v-if="authorizeId=='3'" class="susp-box">
        <AppAside>
          <div>
            <p>
              You can get <strong> Case / Summons / Ticket Number </strong> information on the RI DMV's Notice of action that was mailed to you <br />
              OR <br />
              On the <a href="https://publicportal.courts.ri.gov/PublicPortal" target="_blank" rel="noopener noreferrer">RI Courts public portal</a> 
            </p>
          </div>
        </AppAside>
      </div>
    </div>

    <!-- Business users-->
    <div class="app-main-content guest-signin d-flex" v-if="isIndividual === false">  
      <div class="ind-signin">
        <h1>Sign in</h1>
        <div class="select-ind">
          <!-- businessAuthorizeId starts with value 2 to align with the available business radio options, which correspond to the individual authorizeId options starting from value 2 (vehicle and violation/suspension) -->
          <div class="radio-group">
            <input type="radio" id="Business-Vehicle-RI" class="radio-input" v-model="businessAuthorizeId" value="2" name="businessAuthorizeId" @change="resetForm()">
            <label for="Business-Vehicle-RI" class="radio-label">I have a vehicle in RI</label>
          </div>
          <div class="radio-group">
            <input type="radio" id="Business-Violation-RI" class="radio-input" v-model="businessAuthorizeId" value="3" name="businessAuthorizeId" @change="resetForm()">
            <label for="Business-Violation-RI" class="radio-label">I have a violation / suspension in RI </label>
          </div>
          <div class="radio-group">
            <input type="radio" id="Business-Crash-RI" class="radio-input" v-model="businessAuthorizeId" value="4" name="businessAuthorizeId" @change="resetForm()">
            <label for="Business-Crash-RI" class="radio-label">I have a crash record in RI</label>
          </div>
        </div>
        <LoginForm :businessSelectId="String(businessAuthorizeId)" ref="loginFormRef"/>
      </div>
      <div v-if="businessAuthorizeId=='3'" class="susp-box">
        <AppAside>
          <div>
            <p>
              You can get <strong> Case / Summons / Ticket Number </strong> information on the RI DMV's Notice of action that was mailed to you <br />
              OR <br />
              On the <a href="https://publicportal.courts.ri.gov/PublicPortal" target="_blank" rel="noopener noreferrer">RI Courts public portal</a> 
            </p>
          </div>
        </AppAside>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import appConfig from '@/app.config';
import LoginForm from '../../components/modules/guestLogin/LoginForm.vue';
import SystemAlert from '@/components/SystemAlert.vue';
import AppAside from '../../components/confirmation/AppAside.vue';
import { useHead } from '@unhead/vue'

useHead({
  title: `Home | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: appConfig.description
    }
  ]
});

// Vue router
const route = useRoute();

// Reactive data 
const isIndividual = ref(true);
const activeTab = ref('');

const authorizeId = ref('1');
const businessAuthorizeId = ref('2');  // Business options start with value 2 to align with the corresponding individual options

// Template Refs 
const loginFormRef = ref(null);

// Watcher
watch(isIndividual, (newVal, oldVal) => {
  if (oldVal === true && newVal === false) {
    // Individual - Business
    authorizeId.value = '1';
  }

  if (oldVal === false && newVal === true) {
    // Business - Individual
    businessAuthorizeId.value = '2';
  }
});

// Lifecycle Hook 
onMounted(() => {
  activeTab.value = route.query.activeTab;
  if (activeTab.value === 'businesspage') {
    toggleActiveClass({ indType: false });
  } else {
    toggleActiveClass({ indType: isIndividual.value });
  }

  // DOM manipulations
  window.scroll(0, 0);
  document.body.setAttribute('tabindex', '1');
  document.body.focus();
  document.body.removeAttribute('tabindex');
});

// Methods 
const toggleActiveClass = (data) => {
  isIndividual.value = data.indType;
};

const resetForm = () => {
  if (loginFormRef.value) {
    loginFormRef.value.getFormReset();
  }
};
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/loading";
.declaimer {
  color:black;
  width: 100%;
  height: 100%;
  font-size: 12px;
  padding-left: 6%;
  padding-right: 6%;
  padding-top: 1%;
}

.app-btn-custom {
  text-indent: 1%; 
  height: 75px; 
  width: 25%;

  @media only screen and (max-width: 932px) {
    width: 45%;
  }
}

.select-ind{
  display: flex;
  gap: 2rem;
  .radio-group{
    width: max-content;
    input[type="radio"]:checked + label
    {
      font-weight: bold;
    }
  }
  @media only screen and (max-width: 900px) {
    display: block;
  }
}

.d-flex {
  display: flex;
  align-items: center;
  .susp-box {
    width: 30%;
    @media only screen and (max-width: 599px) {
      width: 100%;
    }
  }
  .app-notice {
    max-width: 100% !important;
  }
}
.ind-signin {
  width: 100%;
  @media only screen and (max-width: 599px) {
    width: 100%;
  }
}

.radio-group {
  .radio-input {
    display: inline-block;
    vertical-align: middle;
  }
}
@media only screen and (max-width: 1280px) {
  .d-flex {
    display: block;
    .susp-box {
      width: 100%;
    } 
  }
}
</style>